import Button from 'antd/lib/button';
import Flex from 'antd/lib/flex';
import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import routesConfig from '../../../config/routes';
import { FlexProps } from 'antd';
import { AnyObject } from 'antd/es/_util/type';

export const links = [
  {
    value: routesConfig.help,
    name: 'Помощь',
  },
  {
    value: routesConfig.partners,
    name: 'Партнерская программа',
  },
  { value: routesConfig.rules, name: 'Правила' },
];

export type IHeaderLinksProps = Omit<FlexProps<AnyObject>, 'children'> & {
  children?: ReactNode;
};

class _HeaderLinks extends Component<IHeaderLinksProps> {
  render() {
    return (
      <Flex gap="small" {...this.props}>
        {links.map(item => (
          <Link key={item.value} to={item.value}>
            <Button type={'text'}>{item.name}</Button>
          </Link>
        ))}
      </Flex>
    );
  }
}

export const HeaderLinks = _HeaderLinks;
